export const StakeTxStatus = {
  PENDING: "PENDING",
  CONFIRMED: "CONFIRMED",
  FAILED: "FAILED",
} as const;

export type StakeTxStatus = (typeof StakeTxStatus)[keyof typeof StakeTxStatus];
